<template>
  <div class="container-fluid">
    <ValidationObserver ref="form" >
      <b-form @submit.prevent="onSubmit">
        <!-- <u>
          <li v-for="e in errors" :key="e.vid">{{e}}</li>
        </u> -->
        <Loading :active="loading" :is-full-page="true"></Loading>
        <div class="row">
          <div class="col-sm-8 col-md-8 mt-sm-5">
            <div class="row">
              <div class="col-sm-4 col-md-4">
                <ValidationProvider name="Nombre" rules="required" v-slot="{ validated, valid }">
                  <b-form-group
                    id="input-group-name"
                    label-for="name"
                    class="mb-0"
                  >
                    <b-form-input v-model="rRq.name" id="name" :state="getState(validated, valid)" placeholder="JOE SMITH"></b-form-input>
                  </b-form-group>
                </ValidationProvider>
              </div>
              <div class="col-sm-8 col-md-8">
                <b-form-group
                  id="input-group-hotel"
                  label-for="toHotel"
                  :class="getClassState(stateToHotel)+' mb-0'"
                >
                  <hotel-autocomplete
                    :default-hotel.sync="rq.toHotel"
                    id="toHotel"
                    :state="stateToHotel"
                    @on-select-hotel="onSelectToHotel"
                  ></hotel-autocomplete> 
                </b-form-group>
              </div>
              <div class="col-sm-12 my-3">
                <b-form-checkbox
                  id="checkbox-address"
                  v-model="addAddress"
                  name="checkbox-address"
                  :value="true"
                  :unchecked-value="false"
                >
                  Agregar dirección del AIRBNB / Casa / Destino
                </b-form-checkbox>
                <div v-if="addAddress">
                  <ValidationProvider name="Dirección" rules="required" v-slot="{ validated, valid }">
                    <b-form-input v-model="rRq.address" id="address" :state="getState(validated, valid)" placeholder="Ingrese la dirección"></b-form-input>
                  </ValidationProvider>
                </div>
              </div>
              <div class="col-sm-3">
                <b-form-group
                  id="input-group-pax"
                  label-for="select-pax"
                  :state="statePax"
                >
                  <b-form-select
                    id="select-service"
                    class="form-control"
                    v-model="rq.pax"
                    @change="changePax"
                  >
                    <b-select-option value="">PASAJEROS</b-select-option>
                    <b-select-option v-for="p in pax" :key="p" :value="p">{{p}}</b-select-option>
                  </b-form-select>
                </b-form-group>
              </div>
              <div class=" col-sm-4 col-md-3">
                <ValidationProvider name="Email" :rules="rulesEmail" v-slot="{ validated, valid }">
                  <b-form-group
                    id="input-group-name"
                    label-for="email"
                  >
                    <b-form-input
                      id="email"
                      v-model="rRq.email"
                      placeholder="email@dominio.com"
                      :state="getState(validated, valid)"
                    ></b-form-input>
                  </b-form-group>
                </ValidationProvider>
              </div>
              <div class="col-8 col-sm-4 col-md-5">
                <MazPhoneNumberInput
                  v-model="phone"
                  placeholder="#Tel"
                  default-country-code="US"
                  @update="countryPhone = $event"
                />
              </div>
              <div class="col-4 col-md-1 p-md-0 d-flex pb-4 pb-md-3 align-items-center text-primary">
                <b-form-checkbox
                  id="checkbox-1"
                  v-model="departure"
                  name="checkbox-1"
                  :value="true"
                  :unchecked-value="false"
                >
                  <font-awesome-icon :icon="['fas', 'arrow-left']"/>
                </b-form-checkbox>
              </div>
            </div>
            <b-card >
              <div class="row">
                <div class="col-md-12">
                  <h3>LLegada</h3>
                </div>
                <div class="col-md-6">
                  <!-- <ValidationProvider name="Aerolinea de llegada" rules="required" v-slot="{ validated, valid }"> -->
                    <b-form-group
                      id="input-group-arrivalAirline"
                      label-for="arrivalAirline"
                      class="m-0 airline-autocomplete"
                    >
                      <autocomplete
                        :search="searchAirlines"
                        placeholder="Aerolinea"
                        aria-label="Aerolinea"
                        :get-result-value="getResultValue"
                        @submit="onSelectArrivalAirline"
                      ></autocomplete>
                    </b-form-group>
                  <!-- </ValidationProvider> -->
                </div>
                <div class="col-md-3">
                  <!-- <ValidationProvider name="Vuelo de llegada" rules="required" v-slot="{ validated, valid }"> -->
                    <b-form-group
                      id="input-group-arrivalFlight"
                      label-for="arrivalFlight"
                      class="m-0"
                    >
                      <b-form-input
                        id="arrivalFlight"
                        v-model="arrivalFlight"
                        placeholder="#VUELO"
                      ></b-form-input>
                        <!-- :state="getState(validated, valid)" -->
                    </b-form-group>
                  <!-- </ValidationProvider> -->
                </div>
                <div class="col-md-3">
                  <!-- <ValidationProvider name="Hora de llegada" rules="required" v-slot="{ validated, valid }"> -->
                    <b-form-group
                      id="input-group-arrivalTime"
                      label-for="arrivalTime"
                      class="m-0"
                    >
                      <b-form-timepicker
                        id="arrivalTime"
                        v-model="arrivalTime"
                        locale="es"
                        label-no-time-selected="Hora"
                      ></b-form-timepicker>
                        <!-- :state="getState(validated, valid)" -->
                    </b-form-group>
                  <!-- </ValidationProvider> -->
                </div>
              </div>
            </b-card>
            <b-card v-if="departure" class="mt-4">
              <div class="row">
                <div class="col-md-12">
                  <h3>Salida</h3>
                </div>
                <div class="col-md-6">
                  <!-- <ValidationProvider name="Aerolinea de salida" rules="required" v-slot="{ validated, valid }"> -->
                    <b-form-group
                      id="input-group-departureAirline"
                      label-for="arrivalAirline"
                      class="m-0 airline-autocomplete"
                    >
                      <autocomplete
                        :search="searchAirlines"
                        placeholder="Aerolinea"
                        aria-label="Aerolinea"
                        :get-result-value="getResultValue"
                        @submit="onSelectDepartureAirline"
                      ></autocomplete>
                      <!-- <b-form-input
                        id="departureAirline"
                        v-model="departureAirline"
                        placeholder="AEROLINEA"
                        :state="getState(validated, valid)"
                      ></b-form-input> -->
                    </b-form-group>
                  <!-- </ValidationProvider> -->
                </div>
                <div class="col-md-3">
                  <ValidationProvider name="Vuelo de salida" rules="required" v-slot="{ validated, valid }">
                    <b-form-group
                      id="input-group-departureFlight"
                      label-for="arrivalFlight"
                      class="m-0"
                    >
                      <b-form-input
                        id="departureFlight"
                        v-model="departureFlight"
                        placeholder="#VUELO"
                        :state="getState(validated, valid)"
                      ></b-form-input>
                    </b-form-group>
                  </ValidationProvider>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-md-6">
                  <ValidationProvider name="Fecha de salida" rules="required" v-slot="{ validated, valid }">
                    <b-form-group
                      id="input-group-departureDate"
                      label-for="departureDate"
                      class="m-0"
                    >
                      <b-form-datepicker
                        id="departureDate"
                        v-model="departureDate"
                        placeholder="Fecha"
                        :date-format-options="{
                          year: 'numeric', month: 'short', day: '2-digit'
                        }"
                        locale="es"
                        :state="getState(validated, valid)"
                        @input="changeDepartureDate"
                      ></b-form-datepicker>
                    </b-form-group>
                  </ValidationProvider>
                </div>
                <div class="col-md-6">
                  <ValidationProvider name="Hora de salida" rules="required" v-slot="{ validated, valid }">
                    <b-form-group
                      id="input-group-departureTime"
                      label-for="departureTime"
                      class="m-0"
                    >
                      <b-form-timepicker
                        id="departureTime"
                        v-model="departureTime"
                        locale="es"
                        label-no-time-selected="Hora"
                        :state="getState(validated, valid)"
                      ></b-form-timepicker>
                    </b-form-group>
                  </ValidationProvider>
                </div>
                <div class="col-md-12">
                  <h5 class="mt-3">Pickup</h5>
                </div>
                <div class="col-md-6">
                  <ValidationProvider name="Fecha de Pickup" rules="required" v-slot="{ validated, valid }">
                    <b-form-group
                      id="input-group-pickupDate"
                      label-for="pickupDate"
                      class="m-0"
                    >
                      <b-form-datepicker
                        id="pickupDate"
                        v-model="pickupDate"
                        placeholder="Fecha"
                        :date-format-options="{
                          year: 'numeric', month: 'short', day: '2-digit'
                        }"
                        locale="es"
                        :state="getState(validated, valid)"
                      ></b-form-datepicker>
                    </b-form-group>
                  </ValidationProvider>
                </div>
                <div class="col-md-6">
                  <ValidationProvider name="Hora de pickup" rules="required" v-slot="{ validated, valid }">
                    <b-form-group
                      id="input-group-pickupTime"
                      label-for="departureTime"
                      class="m-0"
                    >
                      <b-form-timepicker
                        id="pickupTime"
                        v-model="pickupTime"
                        locale="es"
                        label-no-time-selected="Hora"
                        :state="getState(validated, valid)"
                      ></b-form-timepicker>
                    </b-form-group>
                  </ValidationProvider>
                </div>
              </div>
            </b-card>
            <div class="mt-3">
              <b-form-textarea
                id="textarea"
                v-model="rRq.special_request"
                placeholder="Observaciones"
                rows="3"
              ></b-form-textarea>
            </div>
          </div>
          <div class="col-sm-4 col-md-4">
            <div class="d-flex flex-column" style="height:100%">
              <div class="d-flex">
                <div class="flex-grow-1">
                  <div class="form-control flex-grow-1">
                    {{ $moment().format('DD MMMM YY') }}
                  </div>
                </div>
                <div class="ml-3">
                  <div class="form-control">
                    {{ $moment().format('HH:mm a') }}
                  </div>
                </div>
              </div>
              <div class="box-services-radios">
                <b-alert
                  v-if="prices === null"
                  show
                  variant="info"
                >
                  Seleccione un hotel y el # de pasajeros
                </b-alert>
                <b-alert
                  v-if="prices !== null && prices.length == 0"
                  show
                  variant="danger"
                >
                  No existen servicios disponibles
                </b-alert>
                <div v-if="prices !== null && prices.length > 0">
                  <b-button variant="outline-primary" v-b-toggle.collapse-1>
                    <font-awesome-icon :icon="['fas', 'cog']"/> Opciones Cotización
                  </b-button>
                  <b-collapse id="collapse-1" class="mt-2">
                    <b-card>
                      <!-- <b-form-group
                        class="mb-0"
                        v-slot="{ ariaDescribedby }"
                        label="Divisa cotización"
                        label-for="radio-group-currencies"
                      >
                        <b-form-radio-group
                          id="radio-group-currencies"
                          v-model="currency"
                          :options="currencyOptions"
                          :aria-describedby="ariaDescribedby"
                          name="radio-currencies"
                          @change="changeCurrency()"
                        ></b-form-radio-group>
                      </b-form-group>
                      <hr> -->
                      <h4><small>Total sugerido</small> ${{totalQuote}} {{rRq.currency}}</h4>
                    </b-card>
                  </b-collapse>
                  <b-list-group class="mt-3">
                    <b-list-group-item v-for="p in prices" :key="p.id">
                      <b-form-radio
                        v-model="selectedService"
                        name="radio-prices"
                        :value="p.value"
                      >
                        {{p.text}}
                      </b-form-radio>
                    </b-list-group-item>
                  </b-list-group>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-8 col-md-8">
            <div class="my-2 d-flex align-items-center">
              <div v-if="panel === 'cashier'" class="mr-4 d-flex custom-autocomplete">
                <autocomplete
                  :search="searchSellers"
                  placeholder="Vendedor"
                  aria-label="Vendedor"
                  :get-result-value="getResultValueSellers"
                  @submit="onSelectSeller"
                ></autocomplete>
                <b-form-group
                  id="input-group-terminal"
                  label-for="terminal"
                  class="mb-0 ml-2"
                >
                  <b-form-select
                    id="select-terminal"
                    class="form-control"
                    v-model="rRq.terminal"
                  >
                    <!-- :state="getState(validated, valid)" -->
                    <b-select-option value="">Terminal</b-select-option>
                    <b-select-option v-for="p in terminals" :key="p" :value="p">{{p}}</b-select-option>
                  </b-form-select>
                </b-form-group>
                <autocomplete
                  class="ml-2"
                  :search="searchVehicles"
                  placeholder="Placa"
                  aria-label="Placa"
                  :get-result-value="getResultValueVehicle"
                  @submit="onSelectVehicle"
                ></autocomplete>
              </div>  
              <b-form-group class="ml-auto mb-0" v-slot="{ ariaDescribedby }">
                <ValidationProvider name="Zona" rules="required" v-slot="{ validated, valid, errors }" class="ml-auto">
                  <b-form-radio-group
                    id="radio-group-service-areas"
                    v-model="rRq.service_zone"
                    :options="serviceAreas"
                    :aria-describedby="ariaDescribedby"
                    name="service-areas"
                  ></b-form-radio-group>
                  <span class="text-danger">{{errors[0]}}</span>
                </ValidationProvider>
              </b-form-group>
              <b-badge v-if="panel !== 'cashier'" variant="info">Terminal: {{user.terminal}}</b-badge>
            </div>
            <div class="p-3 d-flex bg-primary-20-transparent align-items-center">
              <h5 class="mb-0">Total</h5>
              <!-- <h5 class="mb-0 ml-auto">{{totalQuote ? `$${totalQuote}` : 'Seleccione hotel y # pasajeros'}}</h5> -->
              <b-form-input
                v-if="panel === 'cashier'" 
                id="total"
                v-model="rRq.surplus"
                placeholder="Excedente $"
                class="total-r ml-auto"
              ></b-form-input>
              <ValidationProvider name="Total" rules="required" v-slot="{ validated, valid }" class="">
                <b-form-input
                  id="total"
                  v-model="rRq.total"
                  :state="getState(validated, valid)"
                  placeholder="Total $"
                  class="total-r ml-auto"
                ></b-form-input>
              </ValidationProvider>
              <b-form-select
                id="select-currency"
                class="form-control select-currency-r"
                v-model="rRq.currency"
                @change="changeCurrency()"
              >
                <b-select-option v-for="p in currencies" :key="p.code" :value="p.code">{{p.code}}</b-select-option>
              </b-form-select>
                  <!-- v-if="rRq.currency !== 'MXN'" -->
              <!-- <ValidationProvider name="Total" rules="required" v-slot="{ validated, valid }" class="">
                <b-form-input
                  id="exchange_dollar"
                  v-model="rRq.exchange_dollar"
                  :state="getState(validated, valid)"
                  placeholder="Tipo de cambio a USD"
                  class="exchange-rate"
                ></b-form-input>
              </ValidationProvider> -->
            </div>
            <small v-if="!totalQuote" class="d-block text-danger text-right">Seleccione hotel y # pasajeros</small>
            <div class="d-flex p-2 align-items-center">
              <b-input-group prepend="Folio" class="mb-2 mr-sm-2 mb-sm-0 w-50">
                <ValidationProvider name="Total" rules="required" ref="folioinput" mode="passive" v-slot="{ validated, valid }" class="">
                  <b-form-input
                    id="inline-form-input-folio"
                    v-model="rRq.folio"
                    @click="trigger"
                    :state="getState(validated, valid)"
                    placeholder="Folio">
                  </b-form-input>
                </ValidationProvider>
              </b-input-group>
              <div class="ml-auto">
                <b-form-group class="mb-0" v-slot="{ ariaDescribedby }">
                  <b-form-radio-group
                    id="radio-group-1"
                    v-model="paymentMethod"
                    :options="paymentOptios"
                    :aria-describedby="ariaDescribedby"
                    name="radio-options"
                  ></b-form-radio-group>
                </b-form-group>
              </div>
            </div>
            <div v-if="errors" class="d-flex justify-content-end">
              <ul style="list-style-type:none;">
                <template v-for="(field, i) in errors">
                  <li v-for="(m, index) in field" :key="i+index" class="text-danger text-right">{{ m }}</li>
                </template>
              </ul>
            </div>
            <b-button @click="onSubmit" class="w-100" block variant="primary">Guardar</b-button>
          </div>
          <!-- <div class="col-sm-4 col-md-4">
            <div class="box-currencies">
                <b-form-group class="mb-0" v-slot="{ ariaDescribedby }">
                  <b-form-radio-group
                    id="radio-group-currencies"
                    v-model="currency"
                    :options="currencyOptions"
                    :aria-describedby="ariaDescribedby"
                    name="radio-currencies"
                    @change="changeCurrency()"
                  ></b-form-radio-group>
                </b-form-group>
              </div>
          </div> -->
        </div>
      </b-form>
    </ValidationObserver>
  </div>
</template>
<script>
  import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
  import { required, email } from 'vee-validate/dist/rules'
  extend('email', email)
  extend('required', required)
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
  export default {
    name:'PointSale',
    components:{FontAwesomeIcon, ValidationObserver, ValidationProvider},
    props:{
      currencies:{
        required:true,
        type: Array
      },
      airlines:{
        required:true,
        type: Array
      },
      user: {
        required: true,
        type: Object
      },
      panel: {
        required: false,
        default: 'seller'
      }
    },
    data() {
      let pax = [];
      for (let index = 1; index < 40; index++) {
        pax.push(index)
      }
      return{
        // total: null,
        required:true,
        errors: null,
        countryPhone: null,
        statePax: null,
        stateToHotel: null,
        departure: false,
        loading: false,
        addAddress: false,
        pax,
        phone: '',
        paymentMethod: 'CASH',
        currency: 'usd',
        serviceAreas:[
          { text: 'Local', value: 'local' },
          { text: 'Foraneo', value: 'foreign' },
        ],
        paymentOptios:[
          { text: 'Efectivo', value: 'CASH' },
          { text: 'TDD', value: 'TDD' },
          { text: 'TDC', value: 'TDC' },
        ],
        currencyOptions:[
          { text: 'USD', value: 'usd' },
          { text: 'MXN', value: 'mxn' },
        ],
        rq:{
          service:'a',
          pax:'',
          fromHotel:{
            id:process.env.MIX_AIRPORT_ID,
            name:process.env.MIX_AIRPORT_NAME,
          },
          toHotel:{
            id:'',
            name:''
          }
        },
        prices:null,
        selectedService:null,
        rsQuote:null,
        rRq:{
          panel:this.panel,
          terminal:'',
          name:'',
          email:'',
          surplus:'',
          total:'',
          currency:'USD',
          address:'',
          special_request:'',
          service_zone:'',
          folio:'',
          exchange_dollar:'',
          exchange_mxn:'',
        },
        arrivalAirline: '',
        arrivalFlight: '',
        arrivalTime: '',
        departureAirline: '',
        departureFlight: '',
        departureDate: '',
        departureTime: '',
        pickupDate: '',
        pickupTime: '',
        terminals:['T2','T3','T4',]
      }
    },
    watch: {
      'rRq.folio': async function (newFolio, oldFolio) {
        const provider = this.$refs['folioinput'];
        provider.setErrors(['error']);
        if(newFolio === "" || newFolio === null){
           provider.setErrors(['error']);
        }
          if(newFolio != ""){
            const response = await this.validTicketCode(newFolio);
            if(response.status != 200) {
              // TODO: validate
              provider.setErrors(['error']);
            }else{
              provider.setErrors([]);
            }
          }

      }
    },
    methods:{
      trigger(){
        const provider = this.$refs['folioinput'];
        if(provider.value === ""){
           provider.setErrors(['error']);
        }
      },
      onSelectDepartureAirline(result) {
        this.departureAirline = result.name
      },
      onSelectArrivalAirline(result) {
        this.arrivalAirline = result.name
      },
      getResultValueSellers(result) {
        return result.name
      },
      onSelectSeller(result) {
        this.rRq.seller_id = result.id
      },
      getResultValueVehicle(result) {
        return result.licence_plate
      },
      onSelectVehicle(result) {
        this.rRq.vehicle_id = result.id
      },
      async validTicketCode(code) {
        const url = `${process.env.MIX_APP_URL}/seller/tickets/${code}/valid?terminal=${this.user.terminal}&user_id=${this.user.id}`
          console.log(url);
           return await this.$axios.get(url).then(rs => {
            // console.log('data.data', rs.data);
            return rs.data 
          })
          .catch(error=> {
            console.log('error validating tickets', error);
          })
      },
      searchSellers(input) {
        this.$emit('on-search', {input : input})
        return new Promise(resolve => {
          const url = `${process.env.MIX_APP_URL}/api-feraltar/search-sellers?q=${encodeURI(
            input
          )}`

          if (input.length < 3) {
            return resolve([])
          }
          this.$axios.get(url).then(rs => {
            // console.log('data.data', rs.data);
            resolve(rs.data.sellers)
          })
          .catch(error=> {
            console.log('error search sellers', error);
          })
        })
      },
      searchVehicles(input) {
        this.$emit('on-search', {input : input})
        return new Promise(resolve => {
          const url = `${process.env.MIX_APP_URL}/api-feraltar/search-vehicles?q=${encodeURI(
            input
          )}`

          if (input.length < 3) {
            return resolve([])
          }
          this.$axios.get(url).then(rs => {
            // console.log('data.data', rs.data);
            resolve(rs.data.vehicles)
          })
          .catch(error=> {
            console.log('error search vehicles', error);
          })
        })
      },
      searchAirlines(input) {
        if (input.length < 1) { return [] }
          return this.airlines.filter(airline => {
            return airline.name.toLowerCase()
              .indexOf(input.toLowerCase()) > -1
          })
      },
      getResultValue(result) {
        return result.name
      },
      changeCurrency() {
        if(this.isValidPax() && this.isValidToHotel()) {
          this.quote()
        }
      },
      onSelectToHotel(data) {
        this.rq.toHotel.id = data.id
        this.rq.toHotel.name = data.value
        if(this.isValidPax() && this.isValidToHotel()) {
          this.quote()
        }
      },
      changePax() {
        if(this.isValidPax() && this.isValidToHotel()) {
          this.quote()
        }
      },
      isValidToHotel() {
        if(this.rq.toHotel.id !== '') {
          this.stateToHotel = true
        } else {
          this.stateToHotel = false
        }
        return this.statePax
      },
       isValidPax() {
        if(this.rq.pax !== '') {
          this.statePax = true
        } else {
          this.statePax = false
        }
        return this.statePax
      },
      onSubmit(e) {
        e.preventDefault()
        this.errors = null
        if(this.isValidPax() && this.isValidToHotel()) {
          this.$refs.form.validate().then((success) => {
            if (success) {
              this.loading = true
              const url = `${process.env.MIX_APP_URL}${this.$prefixPanel}/reservations`
              //this.$store.dispatch('quote/setRequest', this.rq)
              const data = this.getDataToBook()
              this.$axios.post(url, data).then(rs => {
                //this.$store.dispatch('quote/setData', rs.data)
                if (!rs.data.error) {
                  window.location.href = url +'/'+ rs.data.id
                  //this.loading = false
                } else {
                  this.loading = false
                }
              })
              .catch(error=> {
                if (error.response) {
                  this.errors = error.response.data.errors
                }  else {
                  this.errors = {
                    unexpected: ['Hubo un error por favor contacte al administrador']
                  }
                }
                console.log('error quote', error);
                this.loading = false
              })
            }
          })
        }
      },
      getDataToBook() {
        let data = {
          customer_name: this.rRq.name,
          contact_email: this.rRq.email,
          panel: this.rRq.panel,
          terminal: this.rRq.terminal,
          seller_id: this.rRq.seller_id,
          vehicle_id: this.rRq.vehicle_id,
          folio: this.rRq.folio,
          contact_phone: this.countryPhone.nationalNumber || '',
          total: this.rRq.total,
          service_zone: this.rRq.service_zone,
          currency: this.rRq.currency,
          address: this.rRq.address,
          special_request: this.rRq.special_request,
          contact_country: this.countryPhone.countryCode,
          departure: this.departure ? 1 : 0,
        }
        data.arrival_date = this.$moment().format('YYYY-MM-DD') + ' ' + this.arrivalTime
        data.arrival_airline = this.arrivalAirline
        data.arrival_flight = this.arrivalFlight
        if (this.departure) {
          data.pickup_time = this.pickupDate + ' ' + this.pickupTime
          data.departure_date = this.departureDate + ' ' + this.departureTime
          data.departure_airline = this.departureAirline
          data.departure_flight = this.departureFlight
        }
        data.pax = this.rq.pax
        data.payment_type = this.paymentMethod
        //data.exchange_dollar = this.rsQuote.quote.exchangeDollar
        //data.exchange_dollar = this.rRq.currency === 'MXN' ? 1 : this.rRq.exchange_dollar
        data.exchange_dollar = this.rRq.exchange_dollar
        data.exchange_mxn = this.rRq.exchange_mxn
        data.from_destination = this.rsQuote.quote.fromDestination
        data.from_destination_id = this.rsQuote.quote.fromDestinationId
        data.from_hotel = this.rsQuote.quote.fromHotel
        data.from_hotel_id = this.rsQuote.quote.fromHotelId
        data.to_destination = this.rsQuote.quote.toDestination
        data.to_destination_id = this.rsQuote.quote.toDestinationId
        data.to_hotel = this.rsQuote.quote.toHotel
        data.to_hotel_id = this.rsQuote.quote.toHotelId
        data.service_id = this.selectedService.id
        data.service_name = this.selectedService.name
        data.base_total = this.totalQuote
        data.surplus = this.rRq.surplus
        
        return data
      },
      changeDepartureDate(date) {
        this.pickupDate = date
      },
      /*validateDepartureAirline() {
        if (this.departure) {
          return this.departureAirline ? true : false
        }
        return true
      },*/
      quote() {
        this.loading = true
        const url = `${process.env.MIX_APP_URL}/api-feraltar/quote-services`
        //this.$store.dispatch('quote/setRequest', this.rq)
        this.rq.currency = this.rRq.currency//this.currency
        console.log(this.rq)
        this.$axios.post(url, this.rq).then(rs => {
          //this.$store.dispatch('quote/setData', rs.data)
          console.log('rs.data', rs.data);
          
          if (!rs.data.error) {
            this.rsQuote = rs.data
            this.rRq.exchange_dollar = rs.data.quote.exchangeDollar
            this.rRq.exchange_mxn = rs.data.quote.exchangeMXN
            this.setServices()
          }
          this.loading = false
        })
        .catch(error=> {
          console.log('error quote', error);
          this.loading = false
        })
      },
      setServices() {
        this.prices = []
        this.selectedService = this.rsQuote.quote.prices[0]
        for (const p of this.rsQuote.quote.prices) {
          this.prices.push({
            text:p.name,
            value:p
          })
        }
      },
      getClassState(state) {
        if (state === null) {
          return ''
        }
        if (state) {
          return 'valid'
        } else {
          return 'is-invalid'
        }
      },
      getState(validated, valid, error = undefined) {
        if (!validated || error) {
          return null;
        }
        return valid
      }
    },
    computed:{
      totalQuote() {
        if (this.rsQuote == null) {
          return null
        }
        if (this.departure) {
          return this.selectedService.totalRT
        }
        return this.selectedService.totalOW
      },
      rulesEmail() {
        if (this.departure) {
          return {
            required: true,
            email: true
          }
        }
        return 'email'
      }
    }
  }
</script>
<style>
/* @import '../../sass/_variables.scss'; */
@import '../../sass/maz-ui.scss';
.maz-phone-number-input .maz-input__label {
  display: none;
}
.maz-phone-number-input .maz-input.has-value:not(.has-no-label) .maz-input__input,
.maz-phone-number-input .maz-input.has-hint:not(.has-no-label) .maz-input__input{
  padding-top: 0;
}
.maz-phone-number-input .maz-phone-number-input__country-flag{
  bottom: 0.7rem;
}
.maz-phone-number-input .country-selector {
  flex: 0 0 6.857rem;
  width: 6.857rem;
  min-width: 6.857rem;
  max-width: 6.857rem;
}
.maz-phone-number-input .maz-input {
  height: calc(1.6em + 0.75rem);
  min-height: calc(1.6em + 0.75rem);
}
</style>